import type { ImageField } from "@prismicio/client"
import React from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"
import type { Nullable } from "@bounce/util"

import { BookNow } from "./components/BookNow"
import { Hero } from "./components/Hero"
import { Reviews } from "./components/Reviews"
import { Layout } from "../../../components/LuggageStorage/Layout/Layout"
import type { AggregateRating } from "../../../libs/bounce/aggregateRating"
import { useUrl } from "../../../libs/router"
import type { Review } from "../../../utils/reviews"

export type ReviewsScreenProps = {
  cityImage: Nullable<ImageField>
  featuredReview: Review
  reviews: Review[]
  aggregateRating: AggregateRating
}

const ReviewsScreen = ({ reviews, featuredReview, cityImage, aggregateRating }: ReviewsScreenProps) => {
  const { t } = useTranslation("marketing-generic")
  const { absolutePath } = useUrl()
  const bounceGlobals = useBounceGlobalValues()

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: t("page.reviews.metaTitleV4", "Bounce - Reviews | Luggage Storage in {{numCities}}+ Cities", {
          numCities: bounceGlobals.numCities,
        }),
        description: t(
          "page.reviews.metaDescription",
          "Read thousands of reviews from Bounce customers across our wide store partner network.",
        ),
      }}>
      <Hero aggregateRating={aggregateRating} featuredReview={featuredReview} cityImage={cityImage} />
      <BookNow className="mt-section" />
      <Reviews reviews={reviews} className="py-section" />
    </Layout>
  )
}

export default ReviewsScreen
